<template>
    <section>
        <div class="role">
            <div class="roleRight">
                <div class="roleRight_Top" style="display: block">
                    <el-button
                        v-if="currentParentId !== 0"
                        @click="handleBackToParent"
                        style="margin-bottom: 10px; margin-right: 10px"
                    >
                        返回：{{ currentParentName }}
                    </el-button>
                    <template>
                        <!-- <el-input
                            clearable
                            v-model="search.name"
                            class="input_search"
                            placeholder="搜索分类名称"
                            style="margin-bottom: 10px;margin-right: 10px"
                            @keyup.enter.native="SearchServiceList"
                        ></el-input> -->

                        <el-select
                            v-model="search.isOffline"
                            clearable
                            filterable
                            placeholder="分类状态"
                            style="margin-bottom: 10px;margin-right: 10px"
                        >
                            <el-option
                                v-for="item in CATEGORY_STATUS"
                                :key="item.key"
                                :label="item.name"
                                :value="item.key"
                            ></el-option>
                        </el-select>

                        <el-button size="medium" type="primary" @click="SearchServiceList"
                        >查询</el-button
                        >
                        <el-button size="medium" @click="handleReset"
                        >重置</el-button
                        >
                    </template>
                    <el-button v-if="addShow&&currentParentId === 0" size="medium" type="primary" @click="handleAddParent"
                    >新增</el-button
                    >
                    <el-button v-if="addShow&&currentParentId !== 0" size="medium" type="success" @click="handleAddChild"
                    >新增</el-button
                    >
                </div>
                <div class="roleRight_Container public-table-data">
                    <el-table
                        :data="treeData"
                        size="medium"
                        border
                        style="width: 100%"
                        v-loading="loading"
                        row-key="id"
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                        :default-expand-all="true"
                    >
                        <el-table-column fixed label="序号" width="80">
                            <template slot-scope="scope">
                                <span>{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="分类信息" min-width="300">
                            <template slot-scope="scope">
                                <div style="display: flex; align-items: center; text-align: left;">
                                    <div style="width: 40px; height: 40px; margin-right: 10px; flex-shrink: 0;" v-if="scope.row.icon">
                                        <img
                                            :src="scope.row.icon"
                                            style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;"
                                        />
                                    </div>
                                    <div style="flex: 1;">
                                        <div v-if="scope.row.parentId === 0" style="font-weight: bold; font-size: 14px; margin-bottom: 5px; cursor: pointer; color: #409EFF;" @click="handleDrillDown(scope.row)">
                                            {{ scope.row.name || '-' }}
                                        </div>
                                        <div v-else style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                                            {{ scope.row.name || '-' }}
                                        </div>
                                        <div style="color: #666; font-size: 12px; margin-bottom: 3px;">
                                            ID：{{ scope.row.id || '-' }}
                                        </div>
                                        <div style="color: #666; font-size: 12px;" v-if="scope.row.description">
                                            {{ scope.row.description || '-' }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="层级" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="getParentTag(scope.row.parentId)" size="mini">
                                    {{ getParentText(scope.row.parentId) }}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="状态" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.isOffline === 0 ? 'success' : 'danger'" size="mini">
                                    {{ scope.row.isOffline === 0 ? '上架' : '下架' }}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column label="排序" width="100" align="center">
                            <template slot-scope="scope">
                                <InlineTableControler
                                    v-model="scope.row.sortOrder"
                                    type="number"
                                    valueKey="sortOrder"
                                    customApi="/course/category/save"
                                    :disabled="!editShow"
                                    :params="scope.row"
                                    @refresh="getCategoryList"
                                />
                            </template>
                        </el-table-column>

                        <el-table-column label="上架" width="80" align="center">
                            <template slot-scope="scope">
                                <InlineTableControler
                                    v-model="scope.row.isOffline"
                                    valueKey="isOffline"
                                    customApi="/course/category/save"
                                    :active-value="0"
                                    :inactive-value="1"
                                    activeColor="#13ce66"
                                    inactiveColor="#ff4949"
                                    :disabled="!statusShow"
                                    :params="scope.row"
                                    @refresh="getCategoryList"
                                />
                            </template>
                        </el-table-column>

                        <el-table-column label="时间信息" min-width="180">
                            <template slot-scope="scope">
                                <div style="font-size: 12px;">
                                    <div>创建：{{ formatDate(scope.row.ctime) }}</div>
                                    <div>更新：{{ formatDate(scope.row.utime) }}</div>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEdit(scope.row)"
                                    type="text"
                                    size="small"
                                    v-if="editShow"
                                >
                                    编辑
                                </el-button>

                                <el-button
                                    @click="handleAddSubCategory(scope.row)"
                                    type="text"
                                    size="small"
                                    v-if="addShow && scope.row.parentId === 0"
                                    style="color: #67C23A"
                                >
                                    添加子分类
                                </el-button>
                                <el-button
                                     @click="handleDrillDown(scope.row)"
                                    type="text"
                                    size="small"
                                    v-if="addShow && scope.row.parentId === 0"
                                    style="color: #67C23A"
                                >
                                    查看子分类
                                </el-button>

                                <el-button
                                    @click="handleDetail(scope.row)"
                                    type="text"
                                    size="small"
                                    v-if="detailShow"
                                >
                                    详情
                                </el-button>

                                <el-button
                                    @click="handleDelete(scope.row)"
                                    type="text"
                                    size="small"
                                    style="color: #f56c6c"
                                    v-if="deleteShow"
                                >
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>

                <div class="roleRight_pagenation">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.pageNo"
                        :page-sizes="[PAGE_SIZE, 15, 20, 25]"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 详情弹窗 -->
        <MultiLanguageDetailDialog
            ref="detailDialog"
            title="分类详情"
            width="1000px"
            :detail-api-template="'/course/category/detail/{id}'"
            :multi-language-fields="['name', 'description']"
        />

        <!-- 编辑弹窗 -->
        <MultiLanguageEditDialog
            ref="editDialog"
            title="分类编辑"
            :api="'/course/category/save'"
            :detail-api-template="'/course/category/detail/{id}'"
            :multi-language-fields="['name', 'description']"
            @success="getCategoryList"
        />
    </section>
</template>
<script>
import {
    PAGE_SIZE,
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import MultiLanguageEditDialog from '@/components/MultiLanguageEditDialog.vue';
import MultiLanguageDetailDialog from '@/components/MultiLanguageDetailDialog.vue';
import InlineTableControler from '@/components/InlineTableControler.vue';

export default {
    components: {
        MultiLanguageEditDialog,
        MultiLanguageDetailDialog,
        InlineTableControler
    },
    data() {
        return {
            PAGE_SIZE,
            formatDate,

            // 分类状态选项
            CATEGORY_STATUS: [
                { key: 0, name: '上架' },
                { key: 1, name: '下架' }
            ],

            parentCategoryList: [], // 父级分类列表
            tableData: [], // 原始分类列表数据
            treeData: [], // 树形结构数据
            loading: false,
            search: {},

            // 分页
            page: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                count: 0
            },

            // 权限控制
            searchShow: true,
            addShow: true,
            editShow: true,
            deleteShow: true,
            statusShow: true,
            detailShow: true,

            // 多语言相关
            languageList: [],
            currentLanguageCode: 'en',

            // 下钻相关
            currentParentId: 0
        };
    },
    created() {
        this.getParentCategoryList();
        this.getCategoryList();
        this.getPermissionButtonList();
        this.getLanguageList();
    },
    methods: {
        // 获取父级分类列表
        async getParentCategoryList() {
            try {
                const { data: res } = await this.$post(
                    `/course/category/list`,
                    { 
                        pageNo: 1, 
                        pageSize: 1000,
                        categoryParentId: 0 // 只获取顶级分类作为父级选项
                    }
                );
                if (res && res.data) {
                    this.parentCategoryList = res.data;
                }
            } catch (error) {
                console.error('获取父级分类列表失败:', error);
            }
        },

        // 获取语言列表
        async getLanguageList() {
            try {
                const { data: res } = await this.$post('/language/list', {
                    adminStatus: 1
                });
                
                if (res && res.data) {
                    this.languageList = res.data;
                    this.currentLanguageCode = (res.data[0] && res.data[0].code) || 'en';
                }
            } catch (error) {
                console.error('获取语言列表失败:', error);
            }
        },

        // 获取权限按钮列表
        getPermissionButtonList() {
            let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
            if (PermissionButtonList) {
                try {
                    let arr = JSON.parse(PermissionButtonList);
                    // 确保arr是数组并且有内容
                    if (Array.isArray(arr) && arr.length > 0) {
                        arr.forEach(item => {
                            if (item.code === 'course:category:query') {
                                this.searchShow = true;
                            }
                            if (item.code === 'course:category:add') {
                                this.addShow = true;
                            }
                            if (item.code === 'course:category:edit') {
                                this.editShow = true;
                            }
                            if (item.code === 'course:category:delete') {
                                this.deleteShow = true;
                            }
                            if (item.code === 'course:category:status') {
                                this.statusShow = true;
                            }
                            if (item.code === 'course:category:detail') {
                                this.detailShow = true;
                            }
                        });
                    }
                } catch (error) {
                    console.error('权限按钮列表解析失败:', error);
                }
            }
        },

        // 搜索
        SearchServiceList() {
            this.getCategoryList();
        },

        // 获取分类列表并转换为树形结构
        async getCategoryList() {
            this.loading = true;
            console.log('this.currentParentId', this.currentParentId)
            try {
                const { data: res } = await this.$post(
                    `/course/category/list`,
                    { 
                        ...this.search, 
                        categoryParentId: this.currentParentId, // 只查当前父级下的
                        pageNo: this.page.pageNo,
                        pageSize: this.page.pageSize
                    },
                    {
                        headers: {
                            isLoading: true,
                        },
                    }
                );
                
                if (res && res.data) {
                    this.tableData = res.data.records || res.data||[];
                    this.page.count = res.page.count || 0;
                    // 不再buildTreeData
                    this.treeData = this.tableData;
                }else{
                    this.tableData = [];
                    this.treeData = [];
                    this.page.count = 0;
                }
            } catch (error) {
                console.error('获取分类列表失败:', error);
                this.$message.error('获取分类列表失败');
            } finally {
                this.loading = false;
            }
        },

        // 新增父分类
        handleAddParent() {
            if (!this.$refs.editDialog) return;
            this.$refs.editDialog.open({ parentId: 0 }, this.getBasicColumns(), { 
                api: '/course/category/save', 
                method: 'post',
                enableMultiLanguage: true,
                languageList: this.languageList
            });
        },

        // 新增子分类
        handleAddChild() {
            if (!this.$refs.editDialog) return;
            // // 检查是否有父分类可选
            // if (!this.parentCategoryList || this.parentCategoryList.length === 0) {
            //     this.$message.warning('请先创建父分类');
            //     return;
            // }
            // 当前在下钻状态，自动回填parentId
            const formData = this.currentParentId !== 0 ? { parentId: this.currentParentId } : {};
            this.$refs.editDialog.open(formData, [{ 
                    label: '父级分类', 
                    prop: 'parentId', 
                    type: 'select', 
                    disabled: true,
                    options: [
                        ...this.parentCategoryList
                    ]
                },...this.getBasicColumns()], { 
                api: '/course/category/save', 
                method: 'post',
                enableMultiLanguage: true,
                languageList: this.languageList
            });
        },

        // 为特定父分类添加子分类
        handleAddSubCategory(parentRow) {
            if (!this.$refs.editDialog) return;
            this.$refs.editDialog.open({ parentId: parentRow.id }, [{ 
                    label: '父级分类', 
                    prop: 'parentId', 
                    type: 'select', 
                    disabled: true,
                    options: [
                        ...this.parentCategoryList
                    ]
                },...this.getBasicColumns()], { 
                api: '/course/category/save', 
                method: 'post',
                enableMultiLanguage: true,
                languageList: this.languageList
            });
        },

        // 编辑分类
        async handleEdit(row) {
            if (!this.$refs.editDialog) return;
            
            console.log('编辑数据:', row);

            const basicColumns = this.getBasicColumns();
            if (row.parentId !== 0) {
                basicColumns.unshift({
                    label: '父级分类',
                    prop: 'parentId',
                    type: 'select',
                    options: [
                        ...this.parentCategoryList
                    ]
                });
            }
            
            this.$refs.editDialog.open(row, basicColumns, { 
                api: '/course/category/save', 
                method: 'post',
                enableMultiLanguage: true,
                languageList: this.languageList
            });
        },

        // 查看详情
        async handleDetail(row) {
            // 检查ref是否存在
            if (!this.$refs.detailDialog) {
                console.error('DetailDialog组件未找到');
                this.$message.error('详情组件加载失败，请刷新页面重试');
                return;
            }

            // 定义分类基础信息列配置
            const basicColumns = [
                // { label: '分类ID', prop: 'id', type: 'text' },
                { label: '分类名称', prop: 'name', type: 'text', span: 2 },
                { label: '分类图标', prop: 'icon', type: 'image' },
                { label: '分类描述', prop: 'description', type: 'text', span: 2 },
                { label: '父级分类', prop: 'parentName', type: 'text' },
                { label: '排序', prop: 'sortOrder', type: 'text' },
                { label: '状态', prop: 'isOffline', type: 'tag', tagMap: {
                    0: { text: '上架', type: 'success' },
                    1: { text: '下架', type: 'danger' }
                }},
                { label: '层级', prop: 'parentId', type: 'tag', tagMap: {
                    0: { text: '父分类', type: 'primary' }
                }, format: (val) => val === 0 ? '父分类' : '子分类' },
                { label: '创建时间', prop: 'ctime', type: 'date' },
                { label: '更新时间', prop: 'utime', type: 'date' },
            ];

            // 构建选项卡数据
            const tabsData = [
                {
                    label: '基础信息',
                    name: 'basic',
                    columns: basicColumns,
                    data: row
                }
            ];

            this.$refs.detailDialog.openWithMultiLanguage(tabsData, {
                enableMultiLanguage: true,
                languageList: this.languageList,
                originalData: row
            });
        },

        // 删除分类
        async handleDelete(row) {
            // 检查是否有子分类
            if (row.children && row.children.length > 0) {
                this.$message.warning('该分类下还有子分类，请先删除子分类');
                return;
            }
            
            try {
                await this.$confirm('确定要删除这个分类吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
                
                // 调用删除接口
                await this.$get(`/course/category/delete/${row.id}`);
                this.$message.success('删除成功');
                this.getCategoryList();
                // 重新获取父分类列表
                this.getParentCategoryList();
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error);
                    this.$message.error('删除失败');
                }
            }
        },

        // 重置搜索条件
        handleReset() {
            this.search = {};
            this.getCategoryList();
        },

        // 分页大小变更
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.getCategoryList();
        },

        // 当前页变更
        handleCurrentChange(val) {
            this.page.pageNo = val;
            this.getCategoryList();
        },

        // 获取层级标签类型
        getParentTag(parentId) {
            return parentId === 0 ? 'primary' : 'warning';
        },

        // 获取层级文本
        getParentText(parentId) {
            return parentId === 0 ? '父分类' : '子分类';
        },

        getBasicColumns() {
            return [
                // { label: 'ID', prop: 'id', type: 'text', addHide: true },
                { 
                    label: '分类名称', 
                    prop: 'name', 
                    type: 'text', 
                    required: true,
                    multiLanguage: true
                },
                { label: '分类图标', prop: 'icon', type: 'image' },
                { 
                    label: '分类简介', 
                    prop: 'description', 
                    type: 'textarea',
                    multiLanguage: true
                },           
           
                { label: '排序', prop: 'sortOrder', type: 'number' },
                { label: '是否下架', prop: 'isOffline', type: 'switch' },
                { label: '创建时间', prop: 'ctime', type: 'date', hide: true, addHide: true, editHide: true },
                { label: '更新时间', prop: 'utime', type: 'date', hide: true, addHide: true, editHide: true },
                { 
                    label: '分类内容', 
                    prop: 'content', 
                    type: 'richText',
                    multiLanguage: true,
                    span:3,
                },
            ];
        },

        // 返回父级
        handleBackToParent() {
            this.currentParentId = 0;
            this.getCategoryList();
        },

        // 下钻
        handleDrillDown(row) {
            this.currentParentId = row.id;
            this.getCategoryList();
        }
    },
    computed: {
        currentParentName() {
            // 先在parentCategoryList找
            let parent = this.parentCategoryList.find(cat => cat.id === this.currentParentId);
            // 再在tableData找
            if (!parent) {
                parent = this.tableData.find(cat => cat.id === this.currentParentId);
            }
            return parent ? parent.name : '';
        }
    },
};
</script>

<style lang="scss" scoped>
.role {
    display: flex;
    gap: 20px;
    color: #666; /** 公共的黑色 --暂定 */
    font-size: 14px;
    &Right {
        flex: 1;
        display: flex;
        overflow-x: hidden;
        flex-direction: column;
        &_Top {
            display: flex;
            gap: 15px;
            .el-input {
                width: auto;
            }
            .timeblock {
                display: flex;
                box-sizing: border-box;
                background: #fff;
                border: 1px solid #dcdfe6;
                border-radius: 5px;
                .cla ::v-deep .el-input--suffix .el-input__inner {
                    padding-right: 0;
                }
                ::v-deep .el-input__inner {
                    border: none !important;
                    height: 38px;
                }
            }
        }
        &_Container {
            margin-top: 20px;
        }
        &_pagenation {
            margin: 40px auto;
        }

        ::v-deep .el-table th,
        ::v-deep .el-table td {
            text-align: center !important;
        }
    }
}

// 树形表格样式优化
::v-deep .el-table {
    .el-table__row {
        .el-table__expand-column {
            .el-table__expand-icon {
                color: #409EFF;
            }
        }
    }
}
</style>